import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import '../style/PrivacyPolicy.css';

const Refund = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
    });

    return () => unsubscribe(); // Cleanup listener
  }, []);

  return (
    <div className="privacy-page">
      {isAuthenticated && <Header />}
      <div className="privacy-container">
        {isAuthenticated && <Sidebar />}
        <div className="main-content">
          <h1>Unitee Refund Policy</h1>

          <p>
            At Unitee, every product is made to order, printed specifically for you. As a Print on Demand service,
            we do not hold inventory and begin production only after you place an order. Because of this custom nature,
            we are unable to offer refunds or returns unless the product is damaged, defective, or incorrect.
          </p>

          <h2>1. Refunds & Replacements Eligibility</h2>
          <p>We will offer a refund or replacement only under the following conditions:</p>
          <ul>
            <li>• You received the wrong product (wrong size, color, or design).</li>
            <li>• The product is defective or damaged on arrival.</li>
            <li>• There are major print errors not matching your approved design.</li>
          </ul>
          <p>In these cases, please contact us within 5 days of delivery with:</p>
          <ul>
            <li>• Your order ID</li>
            <li>• A clear photo of the issue</li>
            <li>• A short description of the problem</li>
          </ul>
          <p>Our team will review the case, and if eligible, a refund or a free replacement will be issued.</p>

          <h2>2. Non-Refundable Situations</h2>
          <p>We do not offer refunds or replacements for:</p>
          <ul>
            <li>• Buyer’s remorse or change of mind</li>
            <li>• Incorrect sizing ordered by the customer (Please refer to our detailed size chart before placing an order)</li>
            <li>• Slight color variations due to screen differences or printing processes (minor shifts are normal)</li>
            <li>•  Delays caused by courier partners (we’ll help escalate if needed, but refunds won’t be issued)</li>
          </ul>

          <h2>3. Cancellation Policy</h2>
          <ul>
            <li>• Orders can be cancelled within 1 hour of placing them. After that, we begin production and cannot process cancellations.</li>
          </ul>

          <h2>4. Refund Timeline</h2>
          <p>
            If a refund is approved, it will be processed to your original payment method within 7–10 business days.
            For replacements, production will begin immediately after approval and will ship within standard timelines.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Refund;
